import { Swiper } from './utils';

const TOTAL_SLIDES = 5

export default function DailyDealsSlider() {
   this.swiper = new Swiper('.swiper-container-solohoras', {
      slidesPerView: TOTAL_SLIDES,
      spaceBetween: 0,
      autoplay: 5000,
      loop: false,
      pagination: {
         el: '.swiper-container-solohoras .swiper-pagination',
         clickable: true,
      },
      navigation: {
         nextEl: '.swiper-button-next-horas',
         prevEl: '.swiper-button-prev-horas',
      },

      breakpoints: {
         // when window width is <= 320px
         320: {
            slidesPerView: 2,
         },
         // when window width is <= 480px
         480: {
            slidesPerView: 2,
         },
         // when window width is <= 640px
         650: {
            slidesPerView: 3,
         },
         800: {
            slidesPerView: 4
         }
      },
      observer: true,
      init: false,
   });

   const ddSectionContainerEl = document.getElementById('section-solo-por-horas')

   this.swiper.on('update', () => {
      const invalidSlideItems = document.querySelectorAll('.js-swiper-dailydeals .swiper-slide.js-item-loaded');
      // console.log("slides" ,invalidSlideItems.length )
      // Ocultar sección si no hay data válida para renderizar
      if (invalidSlideItems.length === TOTAL_SLIDES) {
         if (ddSectionContainerEl) {
            // ddSectionContainerEl.style.display = 'none';
         }
      }
   })

   this.swiper.init()


}